export const EmployerSearchOptInPayload = (JsonData) => {
  const details = JsonData.data.reduce((acc, { name, value }) => {
    acc[name] = value;
    return acc;
  }, {});

  // Helper function to ensure boolean fields have proper True/False values
  const getBooleanValue = (value) => {
    // Handle various input formats
    if (value === "True" || value === true || value === "true") return "True";
    if (value === "False" || value === false || value === "false") return "False";
    // If empty/undefined/null, default to False
    if (value === "" || value === null || value === undefined) {
      return "False";
    }
    // Fallback
    return String(value);
  };

  const payload = {
    id: JsonData.id,
    recordtype: JsonData.recordtype,
    data: [
      {
        name: "ctpt_connectsearch",
        value: getBooleanValue(details["ctpt_connectsearch"]),
        type: "boolean",
      },
      {
        name: "ctpt_discipline",
        value: details["ctpt_discipline"] || "",
        type: "string",
      },
      {
        name: "ctpt_qualifications",
        value: details["ctpt_qualifications"] || "",
        type: "string",
      },
      {
        name: "ctpt_professionalregistration",
        value: details["ctpt_professionalregistration"] || "",
        type: "string",
      },
      {
        name: "ctpt_employmentstatus",
        value: details["ctpt_employmentstatus"] || "",
        type: "optionsetvalue",
      },
      {
        name: "ctpt_willingtorelocate",
        value: details["ctpt_willingtorelocate"] || "",
        type: "optionsetvalue",
      },
      {
        name: "ctpt_employmenttype",
        value: details["ctpt_employmenttype"] || "",
        type: "optionsetvalue",
      },
    ],
  };

  return payload;
};

